import { render, staticRenderFns } from "./LinkKegBit.vue?vue&type=template&id=5aedac70&"
import script from "./LinkKegBit.vue?vue&type=script&lang=js&"
export * from "./LinkKegBit.vue?vue&type=script&lang=js&"
import style0 from "./LinkKegBit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports